import * as serializers from "serializers/legacy/legacy";
export { serializers };
export default serializers;
